module.exports = "<app-location-master></app-location-master> \n<app-print-location></app-print-location>\n"